export function focusNode(id: string, firstChild?: boolean): void {
  const interval = setInterval(() => {
    const container = document.getElementById(id);
    const node =
      firstChild && container
        ? (container.firstChild as HTMLDivElement)
        : container;
    if (node) {
      if (typeof node?.["setFocus"] === "function") {
        const button = node as HTMLCalciteButtonElement;
        button.setFocus();
      } else {
        node.focus();
      }
    }
    if (document.activeElement === node) {
      clearInterval(interval);
      return;
    }
  }, 0);
}

const FOCUSABLE_EL_SELECTORS =
  'button, [href], input[type="text"], select, textarea, [tabindex]:not([tabindex="-1"]), calcite-switch';

export function focusFirstFocusableEl(container: HTMLElement): void {
  const focusableEl = container.querySelectorAll(FOCUSABLE_EL_SELECTORS);
  const firstFocusableEl = focusableEl[0] as HTMLElement;
  const interval = setInterval(() => {
    firstFocusableEl.focus();
    if (document.activeElement === firstFocusableEl) {
      clearInterval(interval);
      return;
    }
  }, 0);
}

export function focusLastFocusableEl(container: HTMLElement): void {
  const focusableEl = container.querySelectorAll(FOCUSABLE_EL_SELECTORS);
  const lastFocusableEl = focusableEl[focusableEl.length - 1] as HTMLElement;
  const interval = setInterval(() => {
    lastFocusableEl.focus();
    if (document.activeElement === lastFocusableEl) {
      clearInterval(interval);
      return;
    }
  }, 0);
}

export function focusSectionEl(currentSectionIndex: number): void {
  const sectionsCalciteActionNode = document.querySelector(
    `.esri-config-panel__calcite-action-node[data-section-index="${currentSectionIndex}"]`
  ) as HTMLCalciteActionElement;
  if (typeof sectionsCalciteActionNode?.["setFocus"] === "function") {
    sectionsCalciteActionNode.setFocus();
  }
}

export function handleFocusElFromSettingsPanel(e: KeyboardEvent): void {
  const node = e.target as HTMLElement;
  const settingsContainerSel = ".esri-config-panel__settings-panel-container";
  const settingsContainerNode = document.querySelector(settingsContainerSel);
  const focusableEl = settingsContainerNode.querySelectorAll(
    FOCUSABLE_EL_SELECTORS
  );

  const firstFocusableEl = focusableEl[0] as HTMLElement;
  const lastFocusableEl = focusableEl[focusableEl.length - 1] as HTMLElement;

  const isTab = e.code === "Tab";
  const shiftKeyPressed = e.shiftKey;

  const currentSectionIndex = parseInt(
    (e.target as HTMLElement).getAttribute("data-section-index")
  );

  if (node === firstFocusableEl) {
    if (isTab && shiftKeyPressed) {
      focusSectionEl(currentSectionIndex);
    }
  } else if (node === lastFocusableEl) {
    if (isTab && !shiftKeyPressed) {
      focusSectionEl(currentSectionIndex);
    }
  }
}

/** Focus function from Calcite */
export async function focusElement(el: any): Promise<void> {
  if (!el) {
    return;
  }

  if (el.nodeName === "CALCITE-DROPDOWN-ITEM") {
    const ddItem: HTMLCalciteDropdownElement = el;
    const btn: HTMLCalciteButtonElement = ddItem.parentElement
      .previousSibling as any;
    btn?.setFocus();
  } else {
    const isCalcite = typeof el.setFocus === "function";

    isCalcite ? el.setFocus() : el.focus();
  }
}
